export const dateFormat = (date) => date.split("-").reverse().join("/")

export const reverseDate = (date) => date.split("-").reverse().join("-")
